module.exports = __webpack_public_path__ + "img/aboutkec.bd4b04da.jpg";